export default __webpack_public_path__ + "static/media/image-1.f2da0c22.png";